import React from 'react';
import CustomCard2 from '../../components/cards/CustomCard2';
import CustomersSidebar from '../../components/sidebars/CustomersSidebar';
import CustomerTable from '../../components/tables/CustomerTable';
import PageLayout from '../layouts/PageLayout';
import { useGetAllCustomersQuery } from '../../api/users/userAPI';
import { useDispatch } from 'react-redux';
import { setCustomers } from '../../features/userSlice';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';
import DataFetchingFeedback from '../../components/feedbacks/DataFetchingFeedback';
import CountBadge from '../../components/CountBadge';
import { isEmpty, size } from 'lodash';

// !############### MAIN FUNC ####################
const Customers = () => {
    const dispatch = useDispatch();
    const {
        data: customers,
        isSuccess,
        isError,
        isLoading,
    } = useGetAllCustomersQuery();

    if (isSuccess) {
        dispatch(setCustomers({ customers: customers.data }));
    }

    return (
        <>
            <PageLayout
                sidebar={<CustomersSidebar />}
                head="Customers managements"
            >
                <CustomCard2
                    title={`CAICA Customers`}
                    height={640}
                    action={
                        <CountBadge
                            total={5}
                            item={'Customers'}
                        />
                    }
                >
                    {isLoading ? (
                        <DataFetchingFeedback />
                    ) : isError ? (
                        <NoDataFeedback message="No customer found" />
                    ) : (
                        <CustomerTable />
                    )}
                </CustomCard2>
            </PageLayout>
        </>
    );
};

export default Customers;
